import { AuthApi } from "../api/Api";
import Auth from "../auth/Auth";
import UriUtils from "../utils/UriUtils";

let googleLogoutPromise = new Promise(function (resolve, reject) {
    Auth.loadGoogleAuthApi(function (error) {
        if(error)
            return reject(error);

        window.gapi.auth2.getAuthInstance().signOut()
            .then(resolve)
            .catch(reject);
    });
});

let facebookLogoutPromise = new Promise(function (resolve, reject) {
    Auth.loadFacebookAuthApi(function(error) {
        if(error)
            return reject(error);

        window.FB.getLoginStatus(function (loginResponse) {
            if (loginResponse.status === "connected") {
                window.FB.logout(resolve);
            } else {
                resolve();
            }
        }, true); // true : will not cache FB requests
    });
});

// Try to logout from Facebook and Google
Promise.all([googleLogoutPromise, facebookLogoutPromise])
    .catch(function (e) {
        console.error("An error occurred while login out from Facebook/Google : ", e);
    })
    .finally(function () {
        // Redirect to SSO (which will determine final redirect page)
        let maybeRedirect = new UriUtils(window.location.search).getQueryParam("redirectUri");

        window.location.replace(AuthApi.logoutAllUri(maybeRedirect));
    });


// WEBPACK FOOTER //
// ./js/page/LogoutPage.js